var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C19.7614 12 22 9.76142 22 7C22 4.23858 19.7614 2 17 2C14.2386 2 12 4.23858 12 7C12 9.76142 14.2386 12 17 12ZM20.0303 6.03033L17.0303 9.03033C16.7374 9.32322 16.2626 9.32322 15.9697 9.03033L14.4697 7.53033C14.1768 7.23744 14.1768 6.76256 14.4697 6.46967C14.7626 6.17678 15.2374 6.17678 15.5303 6.46967L16.5 7.43934L18.9697 4.96967C19.2626 4.67678 19.7374 4.67678 20.0303 4.96967C20.3232 5.26256 20.3232 5.73744 20.0303 6.03033Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98682 20.6309C9.72005 21.47 10.7981 22.0001 12 22.0001C13.2019 22.0001 14.28 21.47 15.0132 20.6309C13.0178 20.956 10.9822 20.956 8.98682 20.6309Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8752 3.00122C8.45342 3.06771 5.70002 5.86231 5.70002 9.30001V11.0505C5.70002 11.6737 5.54497 12.2871 5.24884 12.8355L4.04045 15.0733C3.47924 16.1126 3.92166 17.4096 5.00098 17.8893C9.45687 19.8697 14.5432 19.8697 18.9991 17.8893C20.0784 17.4096 20.5208 16.1126 19.9596 15.0733L18.9494 13.2026C18.334 13.3958 17.6792 13.5 17 13.5C13.4101 13.5 10.5 10.5899 10.5 7.00001C10.5 5.49203 11.0135 4.10399 11.8752 3.00122Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmCheck);
export default __webpack_public_path__ + "static/media/alarm-check.8bb30bb8dd8e7bc0f12ce3969a1e800f.svg";
export { ForwardRef as ReactComponent };